<template lang="pug">
    aside#aside(@click.self="abrirAside(false, ativo)", :class="{'ativo': asideAtivo}")
        .wrapper(v-if="conteudo")
            button(@click="abrirAside(false, ativo)").close
                img(:src="require('@images/icons/close.png')")
            .conteudo
                vuescroll(:ops="ops")
                    div.header
                        .textos
                            h3(v-html="conteudo[ativo].titulo")
                        .image
                            img(:src="conteudo[ativo].image", v-if="conteudo[ativo].image")
                    div.body(v-html="conteudo[ativo].texto")
                    div.galeria(v-if="conteudo[ativo].galeria")
                        button.prev(@click="toggleGaleria(galeriaAtivo - 1)", :disabled="galeriaAtivo <= 0") <
                        ul.items(:style="galeriaStyle")
                            li.item(v-for="item, index in conteudo[ativo].galeria")
                                figure
                                    picture
                                        img(:src="item.imagem", :alt="item.nome")
                                    figcaption
                                        h2 {{ item.nome }}
                                        p(v-html="item.descricao")
                        button.next(@click="toggleGaleria(galeriaAtivo + 1)", :disabled="galeriaAtivo >= conteudo[ativo].galeria.length - 1") >
</template>

<script>
import vuescroll from 'vuescroll/dist/vuescroll-native';

export default {
    name: "component-aside",
    props: {
        conteudo: Array
    },
    components: {
        vuescroll
    },
    data() {
        return {
            asideAtivo: false,
            ativo: 0,
            galeriaAtivo: 0,
            galeriaStyle: {},
            ops: {
                scrollPanel: {
                    scrollingX: false
                },
                bar: {
                    keepShow: true
                }
            }
        }
    },
    mounted() {
        this.$eventBus.$on('keyup', this.abrirAside)
    },
    methods: {
        abrirAside(status = null, conteudoAtivo = null){
            document.querySelector('aside .conteudo').scrollTo(0, 0)
            this.ativo = conteudoAtivo
            this.asideAtivo = status != null ? status : !this.asideAtivo
            if(this.asideAtivo){
                document.querySelector('html').style.overflow = "hidden";
                document.querySelector('body').style.overflow = "hidden";
                document.querySelector('#app').style.overflowY = "hidden";
                document.querySelector('#app').style.perspective = "none";
            } else {
                document.querySelector('html').style.removeProperty('overflow');
                document.querySelector('body').style.removeProperty('overflow');
                document.querySelector('#app').style.removeProperty('overflow-y');
                document.querySelector('#app').style.removeProperty('perspective');
            }
            if(document.querySelector('.body video'))
                document.querySelector('.body video').pause()
        },
        toggleGaleria(index) {
            if (index < 0)
                this.galeriaAtivo = 0
            else if (index >= this.$props.conteudo[this.ativo].galeria.length - 1)
                this.galeriaAtivo = this.$props.conteudo[this.ativo].galeria.length - 1
            else
                this.galeriaAtivo = index
                
            this.galeriaStyle.transform = `translateX(-${this.galeriaAtivo * 100}%)`
        }
    },
}
</script>

<style lang="stylus" scoped src="@components/Aside/Aside.styl"></style>